import api from '@/lib/axios';

class SubmissionService {
  async getUserSubmissions(page = 1, searchParams = {}) {
    try {
      // Build query string with searchParams
      let queryString = `page=${page}`;
      
      // Add name search param if provided
      if (searchParams.name) {
        queryString += `&name=${encodeURIComponent(searchParams.name)}`;
      }
      
      // Add email search param if provided
      if (searchParams.email) {
        queryString += `&email=${encodeURIComponent(searchParams.email)}`;
      }
      
      // Add advisor_id filter if provided
      if (searchParams.advisor_id) {
        queryString += `&legal_advisor=${encodeURIComponent(searchParams.advisor_id)}`;
      }
      
      // Add date filter if provided
      if (searchParams.dateFilter === "custom_range" && searchParams.dateFrom && searchParams.dateTo) {
        // For custom date range, use the required format
        queryString += `&date_filter=custom_range`;
        queryString += `&start_date=${encodeURIComponent(searchParams.dateFrom)}`;
        queryString += `&end_date=${encodeURIComponent(searchParams.dateTo)}`;
      } else if (searchParams.dateFilter) {
        // For predefined date filters, just pass the value directly
        queryString += `&date_filter=${encodeURIComponent(searchParams.dateFilter)}`;
      }
      
      // Add sort parameters if provided
      if (searchParams.sortField) {
        queryString += `&sort_by=${encodeURIComponent(searchParams.sortField)}`;
      }
      
      // Changed from sortOrder to sort_direction to match API endpoint
      if (searchParams.sortOrder) {
        queryString += `&sort_direction=${encodeURIComponent(searchParams.sortOrder)}`;
      }
      
      const response = await api.get(`/v1/User-submissions?${queryString}`);
      return response.data;
    } catch (error) {
      console.error("Error in getUserSubmissions:", error);
      throw error;
    }
  }
}

export const submissionService = new SubmissionService(); 